var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.138,
    height: 14.217,
    viewBox: "0 0 21.138 14.217",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4334",
    "data-name": "Group 4334",
    transform: "translate(-601.809 290.427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14870",
    "data-name": "Path 14870",
    d: "M622.947-286.912a1.382,1.382,0,0,1-.774.932c-.032.014-.052.074-.063.117q-.644,2.59-1.285,5.18c-.107.429-.3.565-.779.567q-5.212.019-10.423.035c-1.617,0-3.234,0-4.851,0-.536,0-.692-.123-.82-.64-.4-1.626-.816-3.251-1.211-4.88a.671.671,0,0,0-.345-.492,1.215,1.215,0,0,1-.352-1.761,1.241,1.241,0,0,1,1.787-.241,1.233,1.233,0,0,1,.137,1.8c-.036.039-.071.08-.132.15.286.278.568.549.846.823s.565.583.863.859a2.181,2.181,0,0,0,3.193-.207c.685-.843,1.319-1.727,1.974-2.594.228-.3.451-.608.685-.9a.176.176,0,0,0,0-.263,1.222,1.222,0,0,1-.014-1.494,1.247,1.247,0,0,1,1.459-.408,1.2,1.2,0,0,1,.759,1.285,4.36,4.36,0,0,1-.281.784l1.714,2.3q.42.562.841,1.123a2.215,2.215,0,0,0,3.475.258q.725-.719,1.445-1.445c.038-.038.073-.079.118-.128a1.3,1.3,0,0,1-.447-1.049,1.249,1.249,0,0,1,1.018-1.141,1.244,1.244,0,0,1,1.381.8l.081.232Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14871",
    "data-name": "Path 14871",
    d: "M617.974-248.653q-3.777,0-7.555,0a.611.611,0,0,1-.578-.244.76.76,0,0,1-.115-.364c-.013-.461-.01-.922,0-1.383a.59.59,0,0,1,.608-.616c.062,0,.124,0,.186,0H625.44c.6,0,.8.2.8.807,0,.372,0,.743,0,1.115a.605.605,0,0,1-.686.684Z",
    transform: "translate(-5.565 -27.559)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.c64b8a32f2a389f54410800cd5a69ba7.svg";
export { ForwardRef as ReactComponent };